module.exports = __webpack_public_path__ + "img/4.064ea3ee.png";